var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-loading"},[_c('div',{staticClass:"progress"},[_c('el-progress',{attrs:{"percentage":_vm.percentage,"color":_vm.customColor}})],1),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("\n    Loading results from "+_vm._s(_vm.getRest)+"+ China airports for offering you the best solution.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460b0724","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reception/public/progressLoading.vue
// module id = null
// module chunks = 